import { useMemo } from 'react';

let idCounter = 0;

const useUniqueId = (prefix?: string): string =>
  useMemo(
    () => `${prefix != null ? prefix + '-' : ''}unique-id-${idCounter++}`,
    [prefix],
  );

export default useUniqueId;
